
import React, { useState, useEffect } from "react";
import "./Alliteams.css";
import { Link, useLocation } from "react-router-dom";
import {
  FaBars,
  FaTimes,
  FaUser,
  FaCreditCard,
  FaList,
  FaHeart,
  FaWallet,
} from "react-icons/fa";

import "semantic-ui-css/semantic.min.css";

import Personalprofilemain from "./Personalprofilemain";
import Payment from "./Payment";
import Order from "./Order";
import Favorites from "./Favorites";
import AddWalletEmployee from "./AddWalletEmpolyee";
import SidescrollAdvertisements from "./SidescrollAdvertisements";
import Profesanlwaleet from "./Profesanlwaleet";

const Profilepage = () => {
  const userType = localStorage.getItem("userType"); // "PROFESSIONAL" | anything else

  const [activeCategory, setActiveCategory] = useState("Profile");
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const location = useLocation();

  /* ---------------- RESPONSIVE ---------------- */
  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth < 768);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  /* ---------------- LOCATION STATE ---------------- */
  useEffect(() => {
    if (location.state?.activeCategory) {
      setActiveCategory(location.state.activeCategory);
    }
  }, [location]);

  /* ---------------- MENU CLICK ---------------- */
  const handleClick = (category) => {
    setActiveCategory(category);
    if (isMobile) setIsMenuOpen(false);
  };

  /* ---------------- ICON MAP ---------------- */
  const iconMap = {
    Profile: <FaUser />,
    Wallet: <FaCreditCard />,
    Orders: <FaList />,
    Favorites: <FaHeart />,
    "Professional Wallet": <FaWallet />,
    "Add Employee": <FaCreditCard />,
  };

  /* ---------------- MENU BASED ON USER TYPE ---------------- */
  const menuCategories =
    userType === "PROFESSIONAL"
      ? ["Profile", "Professional Wallet", "Add Employee"]
      : ["Profile", "Wallet", "Orders", "Favorites"];

  return (
    <div className="profile-page-container">
      <div className="container-fluid">
        <div className="row">
          {/* Header with Breadcrumb - Visible on all screens */}
          <div className="col-12">
            <div
              className="profile-header"
              style={{
                width: "100%",
                textAlign: "left",      // 🔥 pura left align
                display: "flex",
                alignItems: "center",
              }}
            >
              <p
  className="breadcrumb"
  style={{
    margin: 0,
    paddingLeft: "0px",
    textAlign: "left",
    display: "inline-block",  // 🔹 only takes the width of content
    position: "fixed",         // 🔹 fixes at top
    top: isMobile ? "28px" : "65px",  // 🔹 ternary operator              // 🔹 distance from top
    left: "15px",              // 🔹 distance from left
    zIndex: 1000,              // 🔹 stay above other content
    backgroundColor: "transparent", // optional: can use #fff if needed
  }}
>
  <Link
    to="/"
    className="breadcrumb-link"
    style={{ textDecoration: "none", color: "#ee6521", fontSize: "18px" }}
  >
    Home
  </Link>

  <span className="separator" style={{ margin: "0 6px" }}>
    &gt;
  </span>

  <span
    className="breadcrumb-active"
    style={{ fontSize: "18px", fontWeight: "600", color: "#9240b5ff" }}
  >
    {activeCategory}
  </span>
</p>

            </div>
          </div>

          {/* -------- LEFT MENU -------- */}
          <div className="col-lg-2 col-md-3 col-sm-12 col-12">
            {isMobile ? (
              <>
                <div className="mobile-menu-container">
                  <button
                    className="hamburger-btn"
                    onClick={() => setIsMenuOpen(!isMenuOpen)}
                  >
                    {isMenuOpen ? <FaTimes /> : <FaBars />}
                  </button>

                  <div
                    className={`mobile-menu-overlay ${isMenuOpen ? "active" : ""
                      }`}
                  >
                    <div className="mobile-menu-items">
                      {menuCategories.map((category, index) => (
                        <div
                          key={index}
                          className="mobile-menu-item"
                          onClick={() => handleClick(category)}
                          style={{
                            backgroundColor:
                              activeCategory === category
                                ? "rgb(177 93 198)"
                                : "transparent",
                            color:
                              activeCategory === category
                                ? "#fff"
                                : "#333",
                          }}
                        >
                          <span className="mobile-menu-icon">
                            {iconMap[category]}
                          </span>
                          <span className="mobile-menu-text">
                            {category}
                          </span>
                        </div>
                      ))}
                    </div>
                  </div>
                </div>
              </>
            ) : (
              <div className="desktop-sidebar">
                <div className="category-container">
                  {menuCategories.map((category, index) => (
                    <div
                      key={index}
                      className={`category-card compact ${activeCategory === category ? "active" : ""
                        }`}
                      onClick={() => handleClick(category)}
                      style={{
                        backgroundColor:
                          activeCategory === category
                            ? "rgb(177 93 198)"
                            : "#D9D9D9",
                      }}
                    >
                      <span className="icon-wrapper">
                        {React.cloneElement(iconMap[category], {
                          size: 14,
                          color:
                            activeCategory === category ? "#fff" : "#333",
                        })}
                      </span>

                      <span
                        className="category-title"
                        style={{
                          color: activeCategory === category ? "white" : "black",
                          fontSize: "18px",
                        }}
                      >
                        {category}
                      </span>

                    </div>
                  ))}
                </div>
              </div>
            )}
          </div>

          {/* -------- MAIN CONTENT -------- */}
          {/* -------- MAIN CONTENT -------- */}
<div className="col-lg-8 col-md-9 col-12">
  <div className="profile-main-content">
    {/* COMMON */}
    {activeCategory === "Profile" && <Personalprofilemain />}

    {/* -------- NORMAL / PERSONAL LOGIN -------- */}
    {userType !== "PROFESSIONAL" && activeCategory === "Wallet" && (
      <Payment />
    )}

    {userType !== "PROFESSIONAL" && activeCategory === "Orders" && (
      <Order />
    )}

    {userType !== "PROFESSIONAL" && activeCategory === "Favorites" && (
      <Favorites />
    )}

    {/* -------- PROFESSIONAL LOGIN -------- */}
    {userType === "PROFESSIONAL" &&
      activeCategory === "Professional Wallet" && (
        <Profesanlwaleet />
      )}

    {userType === "PROFESSIONAL" &&
      activeCategory === "Add Employee" && (
        <AddWalletEmployee />
      )}
  </div>
</div>


          {/* -------- RIGHT SIDEBAR -------- */}
          <div className="col-lg-3 d-none d-lg-block">
            <SidescrollAdvertisements />
          </div>

        </div>
      </div>
    </div>
  );
};

export default Profilepage;










